module.exports = __webpack_public_path__ + "img/NISSAN.083f3ba.jpg";